(function () {
    "use strict";

    var NoteParameterControl = Solovis.defineClass(
        "Solovis.Reports.Parameters.NoteParameterControl",
        Solovis.UI.BaseControl,
        function (options) {
            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentNote = this.initialParameterValue;
        });

    NoteParameterControl.preload = function (newValue, callback) {
        if (newValue && newValue.noteId) {
            Solovis.Rpc.invoke(
                "~/Selectors/NoteSelector/GetNoteData", { noteId: newValue.noteId },
                function (response, success) {
                    if (success) {
                        var noteData = response.result;
                        callback(noteData, true);
                    }
                    else {
                        callback(null, false);
                    }
                });
        }
        else if (newValue && newValue.resourceId) {
            Solovis.Rpc.invoke(
                "~/Selectors/NoteSelector/GetNoteData", { resourceId: newValue.resourceId },
                function (response, success) {
                    if (success) {
                        var noteData = response.result;
                        callback(noteData, true);
                    }
                    else {
                        callback(null, false);
                    }
                });
        }
        else {
            callback(null, true);
        }
    };

    NoteParameterControl.serializeParameterValue = function (value): any {
        if (value) {
            if (value.noteId) {
                return { noteId: value.noteId };
            }
            else if (value.resourceId) {
                return { resourceId: value.resourceId };
            }
        }

        return null;
    };

    NoteParameterControl.getLabel = function (value): string | undefined {
      return value?.label
    }


    NoteParameterControl.prototype.doInit = function () {        
    };
   
    NoteParameterControl.prototype.doRender = function () {
        var self = this;
        
        this.selectedNoteLabel = $("<a>").appendTo(this.container)
            .click(function (e) {
                if (self.currentNote && self.currentNote.noteId) {
                    Solovis.UI.PopupLinkPanel.showLinks({
                        offset: { left: e.pageX, top: e.pageY },
                        links: Solovis.Reports.ReportLinker.getNoteLinks(self.currentNote.noteId)
                    });
                }
            });
        this.selectNoteLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);
       
        this.selectNoteLink.click(function () {
            self._toggleSelectorDialog(function (note) {
                self._setCurrentNoteData(note);
                self.notifyParameterValueChanged();
            });
        });

        // Set initial parameter value text.
        if (this.currentNote) {
            this._setCurrentNoteData(this.currentNote);
        }
    };

    NoteParameterControl.prototype._setCurrentNoteData = function (noteData) {
        this.currentNote = noteData;
        if (this.currentNote) {
            this.selectedNoteLabel.text(NoteParameterControl.getLabel(this.currentNote) + " ");
        }
        else {
            this.selectedNoteLabel.text("");
        }
    };

    NoteParameterControl.prototype.setParameterValue = function (newValue) {
        this._setCurrentNoteData(newValue);        
    };

    NoteParameterControl.prototype.getParameterValue = function () {
        if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
            return this.initialParameterValue ? this.initialParameterValue : null;
        }
        else if (this.currentNote) {
            return Solovis.deepCopy(this.currentNote);
        }
        else {
            return null;
        }
    };    

    NoteParameterControl.prototype.notifyParameterValueChanged = function () {
        $(this).trigger("parameterValueChanged");
    };


    NoteParameterControl.prototype._toggleSelectorDialog = function (selectionCallback) {
        var self = this;

        if (this._selectionDialog) {
            // We already have the selection dialog open, so close it.
            this._selectionDialog.close();
            this._selectionDialog = null;
            return;
        }


        var selectorControlHostDiv = $("<div>");
        var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });
        var selectorControl = new (Solovis.InvDataSelectors as any).NoteSelectorControl({
            controlHost: selectorControlHostDiv,
            selectionCallback: function (note) {
                selectionCallback(note);
                self._selectionDialog.close();
            },
            cancelCallback: function () {
                self._selectionDialog.close();
            }
        });
        selectorControlHost.setCurrentControl(selectorControl);


        // Determine dialog position.        
        var linkOffset = $(this.selectedNoteLabel).offset();
        var linkHeight = $(this.selectNoteLink).outerHeight();
        var dialogPosition = {
            left: linkOffset.left,
            top: linkOffset.top + linkHeight + 5
        };

        var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

        this._selectionDialog = new Solovis.UI.Dialog({
            container: selectorControlHostDiv,
            ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

            title: false,
            autoOpen: true,
            destroyOnClose: true,
            actions: ["Close"],
            noAnimation: true,
            position: adjustedPosition,

            buttons: [
                {
                    label: "Clear",
                    click: function () {
                        selectionCallback(null);
                        self._selectionDialog.close();
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        self._selectionDialog.close();
                    }
                }
            ],

            activate: function () {
                selectorControl.focus();
            },

            deactivate: function () {
                self._selectionDialog = null;
            }
        });
    };

})();